<div class="d-flex justify-content-between align-items-center ">
  <div class="cust-label">
    <label>{{'BO_UPLOAD_DOCUMENTS' | translate }}</label>
  </div>
  <button type="button" class="close cust-modal-button" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="custMargin">
  <app-file-uploader [path]="path" [maxFiles]="maxFiles" [allowedExtensions]="allowedExtensions" (imagesChanged)="onImagesChanged($event)"></app-file-uploader>

  <div class="d-flex justify-content-end mt-3">
    <button (click)="handleFileUpload()" [disabled]="submitting" class="btn btn-primary">
      @if (submitting) {
        <mat-spinner class="btn-spinner mr-2" diameter="16" strokeWidth="2"></mat-spinner>
        {{ "BO_PROCESSING" | translate }}
      } @else {
        {{ "BO_UPLOAD_BUTTON" | translate }}
      }
    </button>
  </div>
</div>
